export const getConceptConfigurationByConcept = (concept: string) => ({
  method: 'GET',
  url: `/modules/concept-configuration/${concept}`
})
